import { EnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { SortingEffects } from './effects/sorting.effects';
import { SORTING_FEATURE_KEY } from './keys';
import { sortingReducer } from './reducers/sorting.reducer';

export function provideSortingStore(): EnvironmentProviders[] {
    return [provideState(SORTING_FEATURE_KEY, sortingReducer), provideEffects(SortingEffects)];
}
